import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class TokyService {
  constructor(private http: HttpClientService) {}

  public getUsersInformation(from, to): Observable<any> {
    const options = { params: { from, to } };
    return this.http
      .get("/api/toky/users_information", options)
      .pipe(tap((_) => console.log("TokyService.getUsersInformation: Ok.")));
  }

  public sendSms(to, text, email): Observable<any> {
    const params = { to, text, email };
    return this.http.post("/api/toky/send_sms", params).pipe(tap((_) => console.log("TokyService.sendSms: Ok.")));
  }
}
